function t(t){const s=t.replace(/[^\d]/g,""),n=s.substring(0,3),r=s.substring(3,6),e=s.substring(6,10);let u="";return e?u=`(${n}) ${r}-${e}`:r?u=`(${n}) ${r}`:n&&(u=`(${n}`),u}export{t as default};
